/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategoryreceipt2Inputs */

const en_filecategoryreceipt2 = /** @type {(inputs: Filecategoryreceipt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receipt`)
};

const pt_filecategoryreceipt2 = /** @type {(inputs: Filecategoryreceipt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibo`)
};

/**
* | output |
* | --- |
* | "Receipt" |
*
* @param {Filecategoryreceipt2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategoryreceipt2 = /** @type {((inputs?: Filecategoryreceipt2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategoryreceipt2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategoryreceipt2(inputs)
	return pt_filecategoryreceipt2(inputs)
});
export { filecategoryreceipt2 as "fileCategoryReceipt" }